import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'HouseFeatures',
  props: {
    features: {
      type: Object,
      required: true,
    },
    iconSize: {
      type: String,
      default: "small",
    },
    directionLogo: {
      type: Boolean,
      default: false,
    },
    directionLogoCalculator: {
      type: Boolean,
      default: false,
    },
    directionLogoLandPackage: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})